import React, { Component } from 'react';
import Moment from 'react-moment';
import 'moment-timezone';

export default class SiteCount extends Component {
    static displayName = SiteCount.name;

    constructor(props) {
        super(props);
        this.state = { counts: [], siteID: props.siteID, siteName: "" };
    }

    componentDidMount() {
        this.state.siteID !== 0 && fetch('api/Site/GetSiteCount/' + this.state.siteID)
            .then(response => response.json())
            .then(data => {
                console.log("DATA", data)
                this.setState({ counts: data });
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.siteID !== this.props.siteID) {
            this.setState({ siteID: this.props.siteID, siteName: this.props.siteName }, () => {
                fetch('api/Site/GetSiteCount/' + this.state.siteID)
                    .then(response => response.json())
                    .then(data => {
                        this.setState({ counts: data });
                    });
            });
        }
    }

    render() {
        var tabledata = (<table className="table table-striped">
            <thead>
                <tr>
                    <th>Month</th>
                    <th>Count</th>
                </tr>
            </thead>
            <tbody>
                {this.state.counts.map(count =>
                    <tr key={count.date}>
                        <td><Moment format="MMMM, YYYY" utc>{count.date}</Moment></td>
                        <td>{count.counts}</td>
                    </tr>
                )}
            </tbody>
        </table>);
        var loading = (<p>Please select a point on the map to show monthly count data.</p>);
        return (
            <div className="well">
                <h1>{this.state.siteName}</h1>
                {
                    this.state.counts.length > 0 ? 
                    tabledata : loading
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SiteCount.js